// Options of the standard Portal form. Referred is only set by the referral
// flow, so it is never offered here.
export const EXTERNAL_APPLICATION_SOURCE_OPTIONS = [
	{ text: 'LinkedIn', value: 'linkedin' },
	{ text: 'Website', value: 'website' },
	{ text: 'Instagram', value: 'instagram' }
];

export const EXTERNAL_APPLICATION_REFERRED_SOURCE = 'referred';

const EXTERNAL_APPLICATION_SOURCE_LABELS = {
	...Object.fromEntries(
		EXTERNAL_APPLICATION_SOURCE_OPTIONS.map(option => [
			option.value,
			option.text
		])
	),
	[EXTERNAL_APPLICATION_REFERRED_SOURCE]: 'Referred',
	search_engine: 'Found it through search engine',
	referred_prediktive: 'Referred by someone at Prediktive',
	referred_acquaintance: 'Referred by an acquaintance',
	other: 'Other'
};

export const EXTERNAL_APPLICATION_ENGLISH_LEVEL_OPTIONS = [
	{ text: 'None', value: 'none' },
	{ text: 'Beginner', value: 'beginner' },
	{ text: 'Intermediate', value: 'intermediate' },
	{ text: 'Upper Intermediate', value: 'upper_intermediate' },
	{ text: 'Advanced', value: 'advanced' },
	{ text: 'Native', value: 'native' }
];

export const EXTERNAL_APPLICATION_STATUS_OPTIONS = [
	{ label: 'Pending', value: 'pending' },
	{ label: 'Approved', value: 'approved' },
	{ label: 'Rejected', value: 'rejected' }
];

export const EXTERNAL_APPLICATION_APPROVE_PATHS = {
	CURRENT_JOB: 'current_job',
	OTHER_JOBS: 'other_jobs',
	NO_JOB: 'no_job'
};

export function getExternalApplicationSourceLabel(value) {
	return EXTERNAL_APPLICATION_SOURCE_LABELS[value] || value || '—';
}

export function getExternalApplicationSourceChipLabel(value) {
	if (!value) return '—';
	if (value === 'linkedin') return 'Linkedin';
	if (value === EXTERNAL_APPLICATION_REFERRED_SOURCE) return 'Referred';
	return 'Portal';
}

export const EXTERNAL_APPLICATION_STATUS_FILTER_OPTIONS = [
	{ label: 'Status: All', value: null },
	{ label: 'Status: Pending', value: 'pending' },
	{ label: 'Status: Approved', value: 'approved' },
	{ label: 'Status: Rejected', value: 'rejected' }
];

export function getExternalApplicationStatusLabel(value) {
	return (
		EXTERNAL_APPLICATION_STATUS_OPTIONS.find(option => option.value === value)
			?.label ||
		value ||
		'—'
	);
}

export function getExternalApplicationJobId(job) {
	if (!job) return '';
	return job.codes?.[0] ? `#${job.codes[0]}` : `#${job.id}`;
}

export function getExternalApplicationJobTitle(job) {
	return job?.title || job?.role?.name || '';
}

export function getExternalApplicationRoleName(job) {
	return job?.role?.name || '';
}
